import type { Document } from '@/types/document'

function emailInboxAccountName(inbox: string | null | undefined): string | null {
  if (!inbox?.trim()) return null
  const trimmed = inbox.trim()
  const at = trimmed.indexOf('@')
  if (at <= 0) return null
  return trimmed.slice(0, at)
}

export function getSourceDisplay(doc: Document): { label: string; title?: string } {
  if (doc.source_type === 'email') {
    const account = emailInboxAccountName(doc.email_inbox)
    return {
      label: account ? `Email (${account})` : 'Email',
      title: doc.email_inbox || undefined,
    }
  }
  if (doc.source_type === 'upload') {
    return { label: 'Upload' }
  }
  if (doc.source_type === 'amazon_report') {
    const amazon = (doc.extracted_data as { amazon?: { order_id?: string } } | null)?.amazon
    const orderId = amazon?.order_id
    return {
      label: 'Amazon',
      title: orderId ? `Order ${orderId}` : undefined,
    }
  }
  return { label: 'Scan' }
}
